/* 🤖 this file was generated by svg-to-ts */
export const mgcIconArrowRightDownRegular: {
  name: 'arrow-right-down-regular';
  data: string;
} = {
  name: 'arrow-right-down-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.939 5.435a1.099 1.099 0 0 0-.504.504c-.1.22-.097.589.008.821.063.141 1.18 1.28 5.108 5.21L15.58 17h-2.843c-3.232 0-3.121-.01-3.434.303-.183.183-.303.46-.303.697 0 .402.312.827.69.939.308.092 8.312.092 8.62 0 .279-.083.546-.35.629-.629.092-.308.092-8.312 0-8.62C18.827 9.312 18.402 9 18 9c-.237 0-.514.12-.697.303-.313.313-.303.202-.303 3.434v2.843l-5.03-5.029C8.04 6.623 6.901 5.506 6.76 5.443c-.232-.105-.601-.108-.821-.008"/></svg>`
};
